var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#","name":"HeadSort"},on:{"click":function($event){$event.preventDefault();_vm.handleClick($event)}}},[_c('i',{class:_vm.cls})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-713bc0dc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/_utilities/vue2-datatable/Table/HeadSort.vue
// module id = 355
// module chunks = 193